import { render, staticRenderFns } from "./blue-info-modal.vue?vue&type=template&id=3cdc8578&"
import script from "./blue-info-modal.vue?vue&type=script&lang=js&"
export * from "./blue-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports